<template>
  <div ref="svg" style="position: relative;" v-bind:class="['root','ind-chart-' + nameOfChart, {'col_1_2': expanded || $mq === 'sm' || printing}]">
    <h5>{{nameOfChart}}</h5>
    <div class="mapboxgl-ctrl-top-right">
      <div class="mapboxgl-ctrl mapboxgl-ctrl-group">
        <button
          v-bind:class="['mapboxgl-ctrl-icon', {'mapboxgl-ctrl-shrink': expanded, 'mapboxgl-ctrl-fullscreen': !expanded}]"
          v-on:click="expanded = !expanded"
        ><span class="mapboxgl-ctrl-icon" aria-hidden="true"></span></button>
      </div>
    </div>
    <svg
      v-bind:viewBox='"0,0,"+(width + margin.left + margin.right)+","+(height + margin.top + margin.bottom)'
    >
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color:#6f978d;stop-opacity:.1"/>
          <stop offset="100%" style="stop-color:#6f978d;stop-opacity:.9"/>
        </linearGradient>
      </defs>
      <g v-bind:transform="'translate(' + margin.left + ',' + margin.top + ')'">
        <yAxis v-bind:scale="yScale" v-bind:format="format" v-bind:axisWidth="yAxisWidth"/>
        <xAxis
          v-bind:scale="xScaleLinear"
          v-bind:transform="'translate('+yAxisWidth+','+height+')'"
          v-bind:format="xFormat"
          v-bind:tickValues="indicatorsCutoffs && indicatorsCutoffs.slice(1, -1)"
        />
        <g v-bind:transform="'translate(' + yAxisWidth + ',0)'">
          <Bar
            v-for="ind in indicators"
            v-bind:key="ind.name"
            v-bind:tooltip="{
                        content: '<div>' + getIndName(ind.name) + '</div><div>' + tooltipFormat(ind) + '</div>',
                        classes: ['d3-tip'],
                        container: $refs.svg,
                        placement: 'top',
                        boundariesElement: $refs.svg,
                      }"
            v-bind:height="height"
            v-bind:width="xScaleBand.bandwidth()"
            v-bind:step="xScaleBand.step()"
            v-bind:x="xScaleBand(getIndName(ind.name))"
            v-bind:y="[yScale(Math.max(ind.value - ind.moe, 0)), yScale(ind.value), yScale(ind.value + ind.moe)]"
            fill-opacity="0.8"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import yAxis from './yAxis.vue'
import xAxis from './xAxis.vue'
import Bar from './Bar.vue'
import * as d3 from 'd3'

export default {
  name: 'IndDistributionChart',
  components: { Bar, yAxis, xAxis },
  props: [
    'nameOfChart',
    'indicators',
    'indicatorsCutoffs',
    'getIndName',
    'printing',
  ],
  data: function () {
    return {
      margin: { top: 20, right: 10, bottom: 20, left: 10 },
      width: 500,
      height: 150,
      yAxisWidth: 35,
      expanded: false,
    }
  },
  methods: {
    format: d3.format(',d'),
    xFormat: d3.format('$,.2s'),
    tooltipFormat: function (ind) {
      if (ind.moe === 0) {
        return '<strong>' + this.format(ind.value) + '</strong>'
      } else {
        return '<strong>' + this.format(ind.value) + '</strong><small>   +/- ' + this.format(ind.moe) + '</small>'
      }
    },
  },
  computed: {
    xScaleBand: function () {
      let x = d3.scaleBand().padding(0.25).range([0, this.width - this.yAxisWidth])
      x.domain(this.indicators.map(d => this.getIndName(d.name)))
      return x
    },
    xScaleLinear: function () {
      if (this.indicatorsCutoffs) {
        let x = d3.scaleLinear()
        x.range([0].concat(this.indicators.map(ind => this.xScaleBand(this.getIndName(ind.name)) + (this.xScaleBand.step() + this.xScaleBand.bandwidth()) / 2)))
        x.domain(this.indicatorsCutoffs)
        return x
      } else {
        return this.xScaleBand
      }
    },
    yScale: function () {
      let y = d3.scaleLinear().range([this.height, 0])
      if (this.indicators) {
        y.domain([0, d3.max(this.indicators, d => (d.value + d.moe))])
      }
      return y
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only. /deep/ applies to children as well -->
<style scoped>

  .root {
    position: relative;
    background: white;
    padding: 5px;
    margin: 9px;
    border-radius: 5px;
    border-color: #cbc7c7;
    border-width: 1px;
    border-style: solid;
    box-shadow: 10px 20px 17px -8px #cbc7c7;
  }

  svg {
    width: 100%;
  }

  h2, h3, h4, h5, h6 {
    margin: 0;
  }

  @media (max-width: 576px), print {
    .mapboxgl-ctrl-icon {
      display: none;
    }
  }
</style>
